export const API_BASE_URL = 'https://clients.hbwebsol.com';
export const DIRECTORY_URL = 'https://clients.hbwebsol.com/image/getimage/';